import { z } from 'zod'

export const COACHING_BOUNDARIES_CONTRACT_VERSION = '1.0.0' as const

const passthrough = z.unknown()
type BoundaryResponse = z.infer<typeof passthrough>

export const coachingAuthSessionResponseSchema = passthrough
export type CoachingAuthSessionResponse = BoundaryResponse
export const coachingAuthOtpSendResponseSchema = passthrough
export type CoachingAuthOtpSendResponse = BoundaryResponse
export const coachingAuthOtpVerifyResponseSchema = passthrough
export type CoachingAuthOtpVerifyResponse = BoundaryResponse
export const coachingAuthLogoutResponseSchema = passthrough
export type CoachingAuthLogoutResponse = BoundaryResponse

export const coachingXanoMigrationReadinessResponseSchema = passthrough
export type CoachingXanoMigrationReadinessResponse = BoundaryResponse
export const coachingXanoMigrationReconciliationResponseSchema = passthrough
export type CoachingXanoMigrationReconciliationResponse = BoundaryResponse
export const coachingXanoMigrationRunResponseSchema = passthrough
export type CoachingXanoMigrationRunResponse = BoundaryResponse
export const coachingXanoMigrationSourceRecordsResponseSchema = passthrough
export type CoachingXanoMigrationSourceRecordsResponse = BoundaryResponse
export const coachingXanoMigrationFinalizeResponseSchema = passthrough
export type CoachingXanoMigrationFinalizeResponse = BoundaryResponse
export const coachingXanoMigrationImportResponseSchema = passthrough
export type CoachingXanoMigrationImportResponse = BoundaryResponse
export const coachingXanoMigrationClaimResponseSchema = passthrough
export type CoachingXanoMigrationClaimResponse = BoundaryResponse
export const coachingXanoMigrationCompleteResponseSchema = passthrough
export type CoachingXanoMigrationCompleteResponse = BoundaryResponse

export const coachingBindingLookupParticipantResponseSchema = passthrough
export type CoachingBindingLookupParticipantResponse = BoundaryResponse
export const coachingBindingListCohortsResponseSchema = passthrough
export type CoachingBindingListCohortsResponse = BoundaryResponse
export const coachingThinkificSyncResponseSchema = passthrough
export type CoachingThinkificSyncResponse = BoundaryResponse
export const coachingPlatformEventsResponseSchema = passthrough
export type CoachingPlatformEventsResponse = BoundaryResponse
export const coachingReportResultResponseSchema = passthrough
export type CoachingReportResultResponse = BoundaryResponse
export const coachingSideEffectOutboxResponseSchema = passthrough
export type CoachingSideEffectOutboxResponse = BoundaryResponse

export const workAuthSessionResponseSchema = passthrough
export type WorkAuthSessionResponse = BoundaryResponse
export const workAuthLogoutResponseSchema = passthrough
export type WorkAuthLogoutResponse = BoundaryResponse
export const workBindingLookupTaskResponseSchema = passthrough
export type WorkBindingLookupTaskResponse = BoundaryResponse
export const workBindingLookupIssueResponseSchema = passthrough
export type WorkBindingLookupIssueResponse = BoundaryResponse
export const workBindingListProjectsResponseSchema = passthrough
export type WorkBindingListProjectsResponse = BoundaryResponse

export const advisorSessionOrganizationResponseSchema = passthrough
export type AdvisorSessionOrganizationResponse = BoundaryResponse
export const advisorHealthResponseSchema = passthrough
export type AdvisorHealthResponse = BoundaryResponse
export const agentConsoleHealthResponseSchema = passthrough
export type AgentConsoleHealthResponse = BoundaryResponse
export const agentConsoleToolFixtureResponseSchema = passthrough
export type AgentConsoleToolFixtureResponse = BoundaryResponse
export const eventsHealthResponseSchema = passthrough
export type EventsHealthResponse = BoundaryResponse
export const internalEventsResponseSchema = passthrough
export type InternalEventsResponse = BoundaryResponse
export const apiCatalogHealthResponseSchema = passthrough
export type ApiCatalogHealthResponse = BoundaryResponse

export const ADVISOR_SESSION_ORGANIZATION_CONTRACT_VERSION = COACHING_BOUNDARIES_CONTRACT_VERSION
export const ADVISOR_HEALTH_CONTRACT_VERSION = COACHING_BOUNDARIES_CONTRACT_VERSION
export const AGENT_CONSOLE_HEALTH_CONTRACT_VERSION = COACHING_BOUNDARIES_CONTRACT_VERSION
export const AGENT_CONSOLE_TOOL_FIXTURE_CONTRACT_VERSION = COACHING_BOUNDARIES_CONTRACT_VERSION
export const EVENTS_HEALTH_CONTRACT_VERSION = COACHING_BOUNDARIES_CONTRACT_VERSION
export const INTERNAL_EVENTS_CONTRACT_VERSION = COACHING_BOUNDARIES_CONTRACT_VERSION
export const API_CATALOG_HEALTH_CONTRACT_VERSION = COACHING_BOUNDARIES_CONTRACT_VERSION
